import { getAuthorizationToken, onAuthError } from 'Services/ApiAuthToken';

window.ApiClient = (function() {
	const QUERY_TIMEOUT = 120000;
	const VERSION = 2;

	let axiosInstance = axios.create({
		baseURL: window.apiHost + '/v' + VERSION,
		timeout: QUERY_TIMEOUT,
		withCredentials: false,
		headers: {'X-Requested-With': "XMLHttpRequest"}
	});

	let webServiceParamsDefaultValues = {
		params: {},
		data: {},
		headers: {},
		method: 'GET'
	};

	function call(config) {
		if (config.signal?.aborted) {
			return Promise.reject(new DOMException('Aborted', 'AbortError'));
		}
		return new Promise(function (resolve, reject) {

			config.signal?.addEventListener('abort', function () {
				reject(new DOMException('Aborted', 'AbortError'));
			});

			getAuthorizationToken()
				.then(function (token) {
					const callerSignal = config.signal;
					let controller = new AbortController();
					config = $.extend(true, {}, webServiceParamsDefaultValues, config);
					config.headers['Authorization'] = token;
					config.signal = callerSignal ?? controller.signal;
					let promise = axiosInstance.request(config);
					if (promise) {
						promise.abort = () => controller.abort();
					}
					return promise;
				}, onAuthError)
				.then(resolve, reject);
		});
	}


	function post(route, params, data, signal = undefined) {
		return call({url: route, params: params, data: data, method: 'POST', signal});
	}

	function patch(route, params, data, signal = undefined) {

		return call({url: route, params: params, data: data, method: 'PATCH', signal});
	}

	function put(route, params, data, signal = undefined) {

		return call({url: route, params: params, data: data, method: 'PUT', signal});
	}

	function get(route, params, signal = undefined) {

		return call({url: route, params: params, method: 'GET', signal});
	}

	function del(route, params, data = {}, signal = undefined) {
		return call({url: route, params: params, data, method: 'DELETE', signal});
	}

	async function fetchAll(url, method = 'GET', params = {}, requestData = {}, signal = undefined) {
		let data = [];
		let pagination = { offset: '', total: 1 };
		const limit = 100;
		do {
			const paginationParams = { limit, offset: pagination.offset, ...params };
			let response;
			if (method === 'POST') {
				response = await post(url, paginationParams, requestData, signal);
			} else {
				response = await get(url, paginationParams, signal);
			}
			pagination = response.data?.pagination ?? pagination;
			data = data.concat(response.data?.data ?? []);
		} while (data.length < pagination.total);

		return data;
	}

	async function fetchAllGet(url, params = {}, signal = undefined) {
		return fetchAll(url, 'GET', params, {}, signal);
	}

	async function fetchAllPost(url, params = {}, requestData = {}, signal = undefined) {
		return fetchAll(url, 'POST', params, requestData, signal);
	}

	return {
		call: call,
		post: post,
		get: get,
		patch : patch,
		put : put,
		del : del,
		fetchAll: fetchAll,
		fetchAllGet: fetchAllGet,
		fetchAllPost: fetchAllPost,
		isCancel: (error) => error.name === 'AbortError',
	};
})();
